import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./prompt-exit.i18n.json'));

import type {
  PromptExitAdditionalContent
} from 'types';

type Props = {
  title?: string,
  message?: string,
  action?: string,
  actionButtonLabel?: string,
  actionButtonColor?: string,
  cancelButtonLabel?: string,
  innerContent?: string,
  type: 'page' | 'modal' | 'panel',
  additionalContent?: PromptExitAdditionalContent
};

const PromptExit = (
  {
    title,
    message,
    type,
    innerContent,
    action,
    actionButtonLabel,
    actionButtonColor,
    cancelButtonLabel,
    additionalContent
  }: Props
): JSX.Element => <div
  className={`js-prompt-exit-${type}`}
  data-title={encodeURIComponent(title || __t(`prompt_exit.${type}.title`))}
  data-message={encodeURIComponent(message || __t(`prompt_exit.${type}.message`))}
  data-action={encodeURIComponent(action || '')}
  data-confirm-button-label={encodeURIComponent(actionButtonLabel || '')}
  data-cancel-button-label={encodeURIComponent(cancelButtonLabel || '')}
  data-action-button-color={encodeURIComponent(actionButtonColor || '')}
  data-inner-content={innerContent || ''}
  data-additional-content={
    additionalContent && encodeURIComponent(JSON.stringify(additionalContent))
  }
/>;

export default PromptExit;
